import { yupResolver } from "@hookform/resolvers/yup";
import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  resetSearchInvoiceErrorInvoices,
  searchInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import {
  invoiceTypeMode,
  KyHieuMauHoaDonList,
  tableFormateDate,
} from "./utils";

const SearchInvoice = props => {
  const {
    isOpenModal,
    toggleModal,
    dataSearchInvoice,
    setDataSearchInvoice,
    addNewLine,
    bu_code,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { addToast } = useToasts();

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingSearchInvoice,
    errorSearchInvoice,
    searchInvoice: errorInvoicesSearchInvoice,
  } = errorInvoices;

  const Dashboard = useSelector(state => state.Dashboard);
  const { listBuOfTenant, listBuStore } = Dashboard;

  const [resultSearch, setResultSearch] = useState(null);

  const schema = yup.object().shape({
    khmhdon: yup.object(),
    khhdon: yup
      .string()
      .required(t("form.validate.required", { title: t("form.khhdon") }))
      .max(100, t("form.validate.char_max", { max: 100 })),
    shdon: yup
      .string()
      .required(t("form.validate.required", { title: t("form.so_hoa_don") }))
      .matches(/^[0-9]+$/, t("form.validate.integer")),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      khmhdon: undefined,
      khhdon: "",
      shdon: "",
    },
  });

  // Modal Closed
  useEffect(() => {
    if (!isOpenModal) {
      setResultSearch(null);
      reset({
        khmhdon: undefined,
        khhdon: "",
        shdon: "",
      });
      dispatch(resetSearchInvoiceErrorInvoices());
    }
  }, [dispatch, isOpenModal]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesSearchInvoice && errorInvoicesSearchInvoice.success) {
      if (errorInvoicesSearchInvoice.data) {
        setResultSearch(errorInvoicesSearchInvoice.data);
      }
      dispatch(resetSearchInvoiceErrorInvoices());
    }
  }, [dispatch, errorInvoicesSearchInvoice]);

  // Error Dispatch
  useEffect(() => {
    if (errorSearchInvoice) {
      if (
        errorSearchInvoice.status &&
        errorSearchInvoice.status === "NOT_FOUND"
      ) {
      } else {
        addToast(
          formConvertErrorMessage(
            errorSearchInvoice.message ||
              t("message.search_invoice", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
    }
  }, [addToast, errorSearchInvoice, t]);

  const onSubmit = values => {
    dispatch(
      searchInvoiceErrorInvoices({
        khhdon: values.khhdon,
        shdon: values.shdon,
        bu_code: bu_code,
      })
    );
    setResultSearch(null);
  };

  const khmhdonHandler = () => {
    let khhdonPrefix = "";
    const ye = new Intl.DateTimeFormat("en", { year: "2-digit" }).format(
      new Date()
    );

    const buTenant = localStorage.getItem("BU_STORE_HEADER");
    let value = null;
    let dataBu = null;
    if (listBuStore && listBuStore.length > 0) {
      value = listBuStore.find(item => item.value === buTenant);
      dataBu = value;
    } else {
      value = listBuOfTenant.find(item => item.code === buTenant);
      dataBu = value && value.itemBU;
    }

    switch (String(dataBu?.invoice_type)) {
      case invoiceTypeMode.NONE_CODE:
        khhdonPrefix += "K";
        break;
      case invoiceTypeMode.HAVE_CODE:
        khhdonPrefix += "C";
        break;
      default:
        break;
    }

    khhdonPrefix += String(ye);

    const khmhdonValue = getValues("khmhdon");
    const prefixFind = KyHieuMauHoaDonList.find(
      item => item.value === khmhdonValue.value
    );
    if (prefixFind) {
      khhdonPrefix += prefixFind.prefix;
    }

    setValue("khhdon", khhdonPrefix, { shouldValidate: true });
    setFocus("khhdon");
  };

  const addToInvoiceListHandler = () => {
    const resultFind = dataSearchInvoice.find(
      item => item.id === resultSearch.id
    );
    if (resultFind) {
      addToast("Hóa đơn này đã được thêm vào", {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      addToast("Thêm vào danh sách thành công", {
        appearance: "success",
        autoDismiss: true,
      });
      setDataSearchInvoice([...dataSearchInvoice, resultSearch]);

      const khmhdonFind = KyHieuMauHoaDonList.find(
        item => item.value === resultSearch.ttchung_khmshdon
      );

      const dateNgayLap =
        resultSearch.ttchung_nlap &&
        new Date(Number(resultSearch.ttchung_nlap) * 1000).toString() !==
          "Invalid Date"
          ? [new Date(Number(resultSearch.ttchung_nlap) * 1000)]
          : [];

      addNewLine({
        id_invoice: resultSearch.id,
        ma_cqt_cap: resultSearch.mccqt,
        khmhdon: khmhdonFind
          ? khmhdonFind
          : resultSearch.ttchung_khmshdon
          ? {
              value: resultSearch.ttchung_khmshdon,
              label: resultSearch.ttchung_khmshdon,
            }
          : undefined,
        khhdon: resultSearch.ttchung_khhdon,
        so_hoa_don: Number(resultSearch.ttchung_shdon),
        ngay_lap_hdon: dateNgayLap,
        tchat_thong_bao: undefined,
        ly_do: "",
      });
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        contentClassName="select-job-modal"
        className="exampleModal"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {t("title.search_invoice")}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="khmhdon">{t("form.khmhdon")}</Label>
                  <Controller
                    control={control}
                    name="khmhdon"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: t("form.khmhdon"),
                        })}
                        options={
                          KyHieuMauHoaDonList && KyHieuMauHoaDonList.length > 0
                            ? KyHieuMauHoaDonList.map(item => ({
                                value: item.value,
                                label: item.label,
                              }))
                            : []
                        }
                        onChange={data => {
                          field.onChange(data);
                          khmhdonHandler();
                        }}
                        classNamePrefix="select2-selection"
                      />
                    )}
                  />
                  {errors.khmhdon && (
                    <MessageFormValidate error={errors.khmhdon.message} />
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="khhdon">
                    {t("form.khhdon")} <span className="text-danger">*</span>
                  </Label>
                  <Controller
                    control={control}
                    name="khhdon"
                    render={({ field }) => (
                      <input
                        {...field}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "khhdon"
                        )}`}
                        onChange={data => {
                          field.onChange(data.target.value.toUpperCase());
                        }}
                        placeholder={t("placeholder.enter", {
                          title: t("form.khhdon"),
                        })}
                      />
                    )}
                  />
                  {errors.khhdon && (
                    <MessageFormValidate error={errors.khhdon.message} />
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="shdon">
                    {t("form.shdon")} <span className="text-danger">*</span>
                  </Label>
                  <input
                    type="number"
                    className={`form-control ${formValidate(
                      errors,
                      touchedFields,
                      "shdon"
                    )}`}
                    placeholder={t("placeholder.enter", {
                      title: t("form.shdon"),
                    })}
                    {...register("shdon")}
                  />
                  {errors.shdon && (
                    <MessageFormValidate error={errors.shdon.message} />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="fas fa-search label-icon" />
                  {t("form.search")}
                </Button>
              </Col>
            </Row>
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Kết quả:</Label>
              </Col>
              {loadingSearchInvoice ? (
                <LoadingTableNormal countColumn="4" countRow="1" />
              ) : resultSearch && Object.keys(resultSearch).length > 0 ? (
                <React.Fragment>
                  <Col>
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu mẫu hóa đơn</th>
                          <th>Ký hiệu hóa đơn</th>
                          <th>Số hóa đơn điện tử</th>
                          <th>Ngày lập hóa đơn</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{resultSearch.mccqt}</td>
                          <td>{resultSearch.ttchung_khmshdon}</td>
                          <td>{resultSearch.ttchung_khhdon}</td>
                          <td>{resultSearch.ttchung_shdon}</td>
                          <td>{tableFormateDate(resultSearch.ttchung_nlap)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary btn-label"
                      onClick={addToInvoiceListHandler}
                    >
                      <i className="fas fa-plus fa-lg label-icon" />
                      Thêm vào danh sách hóa đơn
                    </button>
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {errorSearchInvoice &&
                    errorSearchInvoice.status &&
                    errorSearchInvoice.status === "NOT_FOUND" && (
                      <Col>
                        <div className="alert alert-warning" role="alert">
                          <span className="pe-1">
                            <i className="fas fa-exclamation-circle fa-lg"></i>
                          </span>
                          <span>Không tìm thấy hóa đơn</span>
                        </div>
                      </Col>
                    )}
                </React.Fragment>
              )}
            </Row>

            <hr />
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Danh sách hóa đơn đã chọn :</Label>
              </Col>
              {dataSearchInvoice && dataSearchInvoice.length > 0 ? (
                <React.Fragment>
                  <Col>
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu mẫu hóa đơn</th>
                          <th>Ký hiệu hóa đơn</th>
                          <th>Số hóa đơn điện tử</th>
                          <th>Ngày lập hóa đơn</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSearchInvoice.map(item => {
                          return (
                            <tr key={item.id}>
                              <td>{item.mccqt}</td>
                              <td>{item.ttchung_khmshdon}</td>
                              <td>{item.ttchung_khhdon}</td>
                              <td>{item.ttchung_shdon}</td>
                              <td>{tableFormateDate(item.ttchung_nlap)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col>
                    <div className="alert alert-info" role="alert">
                      <span className="pe-1">
                        <i className="fas fa-exclamation-circle fa-lg"></i>
                      </span>
                      <span>Chưa có hóa đơn nào được chọn</span>
                    </div>
                  </Col>
                </React.Fragment>
              )}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModal}
                >
                  {t("form.close")}
                </button>
              </Col>
            </Row>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

SearchInvoice.propTypes = {
  bu_code: PropTypes.string,
  // dataDetail: PropTypes.object.isRequired,
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataSearchInvoice: PropTypes.array.isRequired,
  setDataSearchInvoice: PropTypes.func.isRequired,
  addNewLine: PropTypes.func.isRequired,
};

SearchInvoice.defaultProps = {
  bu_code: undefined,
  // dataDetail: {},
  isOpenModal: false,
  dataSearchInvoice: [],
};

export default SearchInvoice;
